import React from 'react'
import { ContentStates, useContext } from './Context'
import { ShowIf } from '@ztechapps/webui.util'
import { BusyButton } from '@ztechapps/webui.button'

export const CreateNewBoardButton = ({ text = 'Create new favorite', icon = 'plus' }) => {
  const { setContentState, contentState } = useContext()

  const onClick = () => {
    setContentState(ContentStates.addBoard)
  }
  return (
    <div>
      <ShowIf condition={contentState !== ContentStates.addBoard}>
        <BusyButton text={text} icon={icon} bsStyle="primary" onClick={onClick} />
      </ShowIf>
    </div>
  )
}
